import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Button, Typography } from "@digital-services/ui";

import PageContentCentered from "@components/PageContentCentered";

const SignedOutPage: FunctionComponent = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "account.signedOut" });

  return (
    <PageContentCentered>
      <Typography className="mb-2" variant="pageTitle" data-testid="page-title">
        {t("page_title")}
      </Typography>

      <div className="text-[18px]">{t("message1")}</div>
      <div className="text-[18px]">{t("message2")}</div>

      <Link to="/">
        <Button size="big" className="mt-6" variant="primary">
          {t("signIn")}
        </Button>
      </Link>
    </PageContentCentered>
  );
};

export default SignedOutPage;
